module.exports = "/static/assets/fb3f9fa9be421f5153cd0223c3b0cb87.svg";